'use client';

import { useDirection } from '@repo/react-hooks';
import { Carousel, CarouselContent } from '@repo/ui/carousel';
import { cn } from '@repo/utils/cn';
import { type ReactNode } from 'react';

type CarouselCardsSectionProps = {
  isCarousel?: boolean;
  headerRenderer?: ReactNode;
  children: ReactNode;
  className?: string;
};

const cardsGridClassName =
  'grid w-full grid-cols-3 gap-1.5 sm:gap-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7';

const CardsSection = ({ isCarousel, headerRenderer, children, className }: CarouselCardsSectionProps) => {
  const direction = useDirection();

  if (!isCarousel) {
    return <section className={cn(cardsGridClassName, className)}>{children}</section>;
  }

  return (
    <section
      className={cn('w-full', className)}
      data-testid="card-section"
    >
      <Carousel
        className="w-full"
        opts={{
          direction,
          dragFree: true,
        }}
      >
        {headerRenderer && <header className="flex min-h-[35px] items-center justify-between">{headerRenderer}</header>}
        <main className="flex justify-center py-1 sm:py-1.5">
          <CarouselContent className="w-full max-w-none gap-1.5">{children}</CarouselContent>
        </main>
      </Carousel>
    </section>
  );
};

export default CardsSection;
